'use strict';

import { hostFactory as hostInstance } from "@api/factory";

import { LoggerBus } from '@app/utils/logger-bus';
const loggerFormat = '[api::my::events]';

const trainingStatus = () =>{
  LoggerBus.$log.debug(loggerFormat);
  return hostInstance.get(`/api/dashboard/training_status`);
}

const eventStatus = () =>{
  LoggerBus.$log.debug(loggerFormat);
  return hostInstance.get(`/api/dashboard/event_status`);
}


export default {
  trainingStatus,
  eventStatus
};